<script setup lang="ts">
import { SwitchRoot, SwitchThumb } from 'radix-vue'

import FormControl from '../FormControl.vue'

type FormControlProps = InstanceType<typeof FormControl>['$props']

type Props = {
  inputClass?: string
  labelPosition?: FormControlProps['labelPosition']
}

defineProps<Props>()

// model
const value = defineModel<boolean>({ default: false })
</script>

<template>
  <FormControl :labelPosition>
    <template #label>
      <slot />
    </template>
    <div :class="inputClass">
      <SwitchRoot
        v-model="value"
        class="bg-neutral-dark-3 border-neutral-light-10 data-[state=checked]:bg-success-4 relative flex h-6 w-11.5 cursor-pointer rounded-full border shadow-sm"
        :checked="value"
        @click="value = !value"
      >
        <SwitchThumb
          class="bg-neutral-light-10 my-auto h-5 w-5 translate-x-0.25 rounded-full shadow-sm transition-transform duration-100 will-change-transform data-[state=checked]:translate-x-5.75"
        />
      </SwitchRoot>
    </div>
  </FormControl>
</template>
